import { graphql } from 'gatsby';
import { VideoContainer, VideoIFrame } from './Video.styles';

// NOTE This component is NOT meant to be used as a standalone component. Please use the SingleMedia component instead.
const Video = ({ videoElements, system }: Queries.VIDEOFragment) => {
  const videoUrl = videoElements.video_url.value;
  const hasLazyLoading = videoElements.options?.value?.includes('lazy_loading') ?? false;
  const description = videoElements.description!.value;

  return (
    <figure data-codename={system.codename}>
      <VideoContainer>
        <VideoIFrame
          src={videoUrl}
          title={description || 'Embedded Video'}
          allowFullScreen
          loading={hasLazyLoading ? 'lazy' : undefined}
        />
      </VideoContainer>
      {description ? <figcaption>{description}</figcaption> : null}
    </figure>
  );
};

export default Video;

export const fragment = graphql`
  fragment VIDEO on kontent_item_video {
    __typename
    videoElements: elements {
      description {
        value
      }
      options {
        value
      }
      video_url {
        value
      }
    }
    system {
      type
      codename
      id
    }
  }
`;
